module.exports = __webpack_public_path__ + "3af9fde4a7939af2a8c4506b375e78b5.jpg";